import api from './api';

export function saveBasicData(data, idCredit) {
  return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/basic-data`, data)
}

export function saveAditionalData(data, idCredit) {
  return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/additional-data`, data)
}

export function saveComplementData(data) {
  return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${data.idCredito}/spouse-data`, data)
}

export function saveWorkData(data, idCredit, subCanal) {
  return api({
    method: 'put',
    url: `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/${subCanal}/work-data`,
    headers: {
      "content-type": "form-data"
    },
    data: data,
  });
}

export function getSolicitaionDataByCreditId(idCredit) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${idCredit}/request-data`)
}

export function postDataSolicitation(data, subCanal) {
  return api.put(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/credits/${data.idCredito}/${subCanal}/simulation-data`, data)
}
